export const INVALID_ACCESS_TOKEN = "token_not_valid"
export const INVALID_REFRESH_TOKEN = "refresh_token_not_valid"
export const USER_NOT_FOUND = "No active account found with the given credentials"
export const UNAUTHORIZED = "You do not have permission to perform this action."
export const EXPIRED_SESSION_MESSAGE = "Your session has expired."
